import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { useValidation } from 'gw-portals-validation-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './OtherDamagePage.metadata.json5';
import LossPropertyIncidentDetail from './../LossPropertyIncidentDetails/LossPropertyIncidentDetails';

function FNOLOtherDamagePage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        }
    } = props;
    const { claimStatus } = state;
    const translator = useContext(TranslatorContext);

    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation
    } = useValidation('FNOLOtherDamagePage');

    const initialiseVM = useCallback(() => {
        return claimVM;
    }, [claimVM]);

    useEffect(
        () => {
            const nextclaimVM = initialiseVM();
            updateWizardData(nextclaimVM);
        },
        // Call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        propertyID: {
            //model: claimVM.lobs.homeowners.incidents,
            propertyOtherDamageVM: claimVM.lobs.homeowners.propertyOtherDamage,
            isComponentValid: isComponentValid,
            onIncidentUpdates: (value) => {
                _.set(claimVM, `lobs.homeowners.propertyOtherDamage.value`, value);
                updateWizardData(claimVM);
            }
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM]
    );

    const resolvers = {
        resolveComponentMap: {losspropertyincidentdetail: LossPropertyIncidentDetail}
    }

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                resolveValue={readValue}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLOtherDamagePage.propTypes = wizardProps;
export default withRouter(FNOLOtherDamagePage);
